import React, { useContext } from 'react';
export const RevealContext = React.createContext(null);
export const useReveal = () => useContext(RevealContext);
//# sourceMappingURL=reveal.context.js.map